function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import localeKeys from '../../../../locales/keys';
import { OFFER_STATUS_INDICATOR_STATUS } from 'invision-core/src/constants/status.constants';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { OFFERING_OPTION_STATUSES } from '../../constants/offering.option.status.constants';
import { OFFERING_METADATA_OFFER_TYPE, PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE } from '../../../../customercare.constants';
import { OfferingOptionBulkTypes } from '../../../../reducers/constants/convergent.biller.constants';
import { CurrentCustomerIdSelector } from '../../../../reducers/selectors/customer.selectors';
import { DBSS_PRODUCT_DETAILS_PAGE_REDIRECT } from '../../../../reactRoutes';
var SubscriberOfferDetails = /*#__PURE__*/function () {
  function SubscriberOfferDetails($ngRedux, $filter, uiNotificationService) {
    _classCallCheck(this, SubscriberOfferDetails);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $filter: $filter,
      filterPricingPlansFromMetaData: this.filterPricingPlansFromMetaData.bind(this),
      getSuspensionDateToolTip: this.getSuspensionDateToolTip.bind(this),
      isCancelEarlyRenewalPaymentModalOpen: false,
      localeKeys: localeKeys,
      OFFER_STATUS_INDICATOR_STATUS: OFFER_STATUS_INDICATOR_STATUS,
      OFFERING_METADATA_OFFER_TYPE: OFFERING_METADATA_OFFER_TYPE,
      OFFERING_OPTION_STATUSES: OFFERING_OPTION_STATUSES,
      onCancelEarlyRenewalPaymentModalClose: this.onCancelEarlyRenewalPaymentModalClose.bind(this),
      onCancelEarlyRenewalPaymentModalSubmit: this.onCancelEarlyRenewalPaymentModalSubmit.bind(this),
      openCancelEarlyRenewalPaymentModal: this.openCancelEarlyRenewalPaymentModal.bind(this),
      openProductDetailsPage: this.openProductDetailsPage.bind(this),
      PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE: PRICING_PLAN_SERVICE_RELATIONSHIP_TYPE,
      thumbnailWidth: 65,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(SubscriberOfferDetails, [{
    key: "$onChanges",
    value: function $onChanges(changeObj) {
      var _this = this;
      if (changeObj.offer && changeObj.offer.currentValue) {
        if (changeObj.offer.currentValue.OfferType === OFFERING_METADATA_OFFER_TYPE.STANDARD && !this.showOfferImage) {
          this.pricingPlansInOffer = changeObj.offer.currentValue.Options.filter(function (option) {
            return _this.serviceIdentifier.find(function (service) {
              return option.ServiceIdentifierValue === service;
            });
          });
        } else {
          this.pricingPlansInOffer = changeObj.offer.currentValue.Options;
        }
        this.setIsPaymentFailedShown();
      }
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToProps = function mapStateToProps(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          isDbss: IsDbss(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, {
        stateGo: stateGo
      })(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.discountToolTip = require('../../../../components/shared/tooltipTemplates/discount.tooltip.html');
      if (this.offerType === OFFERING_METADATA_OFFER_TYPE.STANDARD && !this.showOfferImage) {
        this.pricingPlansInOffer = this.offer.Options.filter(function (option) {
          return _this2.serviceIdentifier.find(function (service) {
            return option.ServiceIdentifierValue === service;
          });
        });
      } else {
        this.pricingPlansInOffer = this.offer.Options;
      }
      this.setIsPaymentFailedShown();
    }
  }, {
    key: "openProductDetailsPage",
    value: function openProductDetailsPage(subscriberProductId) {
      this.actions.stateGo(DBSS_PRODUCT_DETAILS_PAGE_REDIRECT, {
        customerId: this.state.currentCustomerId,
        subscriberProductId: subscriberProductId
      });
    }
  }, {
    key: "setIsPaymentFailedShown",
    value: function setIsPaymentFailedShown() {
      var _this3 = this;
      this.isPaymentFailedShown = this.OFFER_STATUS_INDICATOR_STATUS.ACTIVE === this.offer.Status && this.offer.Options && this.offer.Options.some(function (option) {
        return _this3.isOffCyclePaymentFailed(option);
      });
    }
  }, {
    key: "discountTooltipText",
    value: function discountTooltipText(discounts, billerRuleConfigurationIdOfBri) {
      if (discounts.length > 0) {
        var occurrences = 0;
        discounts.forEach(function (discount) {
          if (discount.billerConfigurationId === billerRuleConfigurationIdOfBri) {
            occurrences++;
          }
        });
        return "".concat(occurrences, " ").concat(i18n.translate(occurrences === 1 ? localeKeys.DISCOUNT : localeKeys.DISCOUNTS_LABEL));
      }
    }
  }, {
    key: "isOffCyclePaymentFailed",
    value: function isOffCyclePaymentFailed(option) {
      return option.OffCycleDetail && option.OffCycleDetail.GracePeriodExpiryDate && option.OffCycleDetail.CurrentRenewalFailedAttempts;
    }
  }, {
    key: "filterPricingPlansFromMetaData",
    value: function filterPricingPlansFromMetaData(offerPricingPlanId) {
      return this.metaDataPricingPlans && this.metaDataPricingPlans[offerPricingPlanId] ? this.metaDataPricingPlans[offerPricingPlanId].Name : undefined;
    }
  }, {
    key: "getItemNameBulk",
    value: function getItemNameBulk(bri, pricingPlanId) {
      var pricingPlanDetails = this.metaDataPricingPlans[pricingPlanId];
      var selectedBriThumbnail = pricingPlanDetails && pricingPlanDetails.BillerRuleInstanceThumbnails ? pricingPlanDetails.BillerRuleInstanceThumbnails.find(function (item) {
        return item.BillerRuleConfigurationId === bri.BillerRuleConfigurationId;
      }) : null;
      return selectedBriThumbnail === null || selectedBriThumbnail === void 0 ? void 0 : selectedBriThumbnail.Name;
    }
  }, {
    key: "getBulkQty",
    value: function getBulkQty(pricingPlanId) {
      var _this$pricingPlansInO, _pricingPlanDetails$B, _pricingPlanDetails$B2;
      var pricingPlanDetails = (_this$pricingPlansInO = this.pricingPlansInOffer) === null || _this$pricingPlansInO === void 0 ? void 0 : _this$pricingPlansInO.find(function (item) {
        return item.PricingPlanId === pricingPlanId;
      });
      return pricingPlanDetails === null || pricingPlanDetails === void 0 ? void 0 : (_pricingPlanDetails$B = pricingPlanDetails.BillerRulePrices) === null || _pricingPlanDetails$B === void 0 ? void 0 : (_pricingPlanDetails$B2 = _pricingPlanDetails$B[0]) === null || _pricingPlanDetails$B2 === void 0 ? void 0 : _pricingPlanDetails$B2.Quantity;
    }
  }, {
    key: "getBulkTooltipContent",
    value: function getBulkTooltipContent(bri) {
      if (bri.BulkType === OfferingOptionBulkTypes.BULK_FLAT) {
        return i18n.translate(localeKeys.DECISIONS.FLAT_PRICING);
      } else if (bri.BulkType === OfferingOptionBulkTypes.BULK_UNIT) {
        return i18n.translate(localeKeys.DECISIONS.UNIT_PRICING);
      }
    }
  }, {
    key: "getBulkIcon",
    value: function getBulkIcon(bri) {
      if (bri.BulkType === OfferingOptionBulkTypes.BULK_FLAT) {
        return 'filled-circle-f';
      } else if (bri.BulkType === OfferingOptionBulkTypes.BULK_UNIT) {
        return 'filled-circle-u';
      }
    }
  }, {
    key: "getSuspensionDateToolTip",
    value: function getSuspensionDateToolTip(date) {
      return i18n.translate(localeKeys.CUSTOMER_DASHBOARD.SUSPENSION_DATE, {
        date: this.$filter('localShortDate')(date)
      });
    }
  }, {
    key: "openCancelEarlyRenewalPaymentModal",
    value: function openCancelEarlyRenewalPaymentModal(pricingPlan) {
      this.transactionId = pricingPlan.OffCycleDetail.LastPaymentTransactionId;
      this.isCancelEarlyRenewalPaymentModalOpen = true;
    }
  }, {
    key: "onCancelEarlyRenewalPaymentModalClose",
    value: function onCancelEarlyRenewalPaymentModalClose() {
      this.isCancelEarlyRenewalPaymentModalOpen = false;
    }
  }, {
    key: "onCancelEarlyRenewalPaymentModalSubmit",
    value: function onCancelEarlyRenewalPaymentModalSubmit(isSuccess, message) {
      if (isSuccess) {
        this.isCancelEarlyRenewalPaymentModalOpen = false;
        this.refreshOfferDetails && this.refreshOfferDetails();
        this.uiNotificationService.transientSuccess(message);
      } else {
        this.uiNotificationService.transientError(message);
      }
    }
  }]);
}();
export default {
  bindings: {
    currency: '<',
    hasAdminAccess: '<?',
    metaDataPricingPlans: '<?',
    offer: '<',
    offerType: '<',
    onMoreItemSelected: '&?',
    openLifeCycleDetailsPopup: '&?',
    navigateToPricingPlanEarlyRenewal: '&?',
    refreshOfferDetails: '&?',
    showOfferImage: '<?',
    serviceIdentifier: '<?'
  },
  template: require('./subscriber.offer.details.html'),
  controller: SubscriberOfferDetails
};